'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { getConsentState, updateGoogleConsent } from '@/lib/consent';

interface GoogleAnalyticsProps {
  gaId: string;
}

export default function GoogleAnalytics({ gaId }: GoogleAnalyticsProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.gtag) return;

    const consent = getConsentState();
    updateGoogleConsent(consent);

    const handleConsentUpdate = (event: CustomEvent) => {
      updateGoogleConsent(event.detail);
    };

    window.addEventListener('consentUpdate' as any, handleConsentUpdate);
    return () => {
      window.removeEventListener('consentUpdate' as any, handleConsentUpdate);
    };
  }, []);

  return (
    <>
      <Script
        id="google-analytics-consent"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            
            // Set default consent to denied
            gtag('consent', 'default', {
              'analytics_storage': 'denied',
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'ad_personalization': 'denied',
              'functionality_storage': 'denied',
              'personalization_storage': 'denied',
              'security_storage': 'granted',
              'wait_for_update': 500
            });
            
            // Set ads data redaction
            gtag('set', 'ads_data_redaction', true);
            
            // Set URL passthrough to improve conversion modeling
            gtag('set', 'url_passthrough', true);
          `,
        }}
      />
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.gtag = gtag;
            gtag('js', new Date());
            gtag('config', '${gaId}', {
              page_path: window.location.pathname,
              cookie_flags: 'SameSite=Lax;Secure'
            });
          `,
        }}
      />
    </>
  );
}